import { render } from "./stockOverview.vue?vue&type=template&id=d3dd9d7a&scoped=true&ts=true"
import script from "./stockOverview.vue?vue&type=script&lang=ts"
export * from "./stockOverview.vue?vue&type=script&lang=ts"

import "./stockOverview.vue?vue&type=style&index=0&id=d3dd9d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dd9d7a"]])

export default __exports__